export const ACCOUNT_ROUTE = "/account";
export const CREATE_DREAM_ROUTE = "/dreamer";
export const DREAM_LOG_ROUTE = "/dreamlog";
export const DREAM_ROUTE = "/dream";
export const SIGNIN_ROUTE = "/signin";
export const WELCOME_ROUTE = "/welcome";
export const MARKETING_PAGE = "/marketing";
export const SUPPORT_PAGE = "/support";
export const PAYWALL_ROUTE = "/paywall";
export const HOME_ROUTE = "/"
export const SUCCESSFUL_PURCHASE_ROUTE = "/success"